"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireWildcard(require("../TextField"));

var _PhoneMaskedInput = _interopRequireDefault(require("./PhoneMaskedInput"));

var _removeNonNumericCharacters = _interopRequireDefault(require("../utils/removeNonNumericCharacters"));

var _excluded = ["onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Text field for entering phone number.
 * See [TextField](/#!/TextField) for props info.
 */
var Phone = function Phone(_ref) {
  var _onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    name: "phone",
    type: "tel",
    autoComplete: "tel",
    inputComponent: _PhoneMaskedInput["default"],
    startAdornment: "+1",
    onChange: function onChange(event, value, helpers, context) {
      var val = (0, _removeNonNumericCharacters["default"])(event.target.value);

      if (_onChange) {
        return _onChange(event, val);
      }

      helpers && helpers.setValue(val);
    }
  }, props));
};

Phone.propTypes = _TextField.TextFieldProps;
var _default = Phone;
exports["default"] = _default;